import { useContext, useState } from 'react';
import { Modal, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { COMPLETE_ID } from '@gtintel/platform-constants';
import { ProjectContext } from '../../../ProjectApp/context';
const CompleteProjectButton = () => {
  const {
    edit
  } = useContext(ProjectContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return <>
      <Modal onClose={() => setIsOpen(false)} closeable isOpen={isOpen} animate autoFocus size={SIZE.default} role={ROLE.dialog}>
        <ModalHeader>
          Are you sure you want to complete this project?
        </ModalHeader>
        <ModalFooter>
          <ButtonRow flexPosition="flex-end">
            <Button kind="error" testId="confirm-complete-project-button" loading={isLoading} disabled={isLoading} onClick={() => {
            setIsLoading(true);
            edit({
              status: COMPLETE_ID
            });
            setIsLoading(false);
            setIsOpen(false);
          }}>
              Complete Project
            </Button>
            <Button kind="secondary" testId="cancel-complete-project-button" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </ButtonRow>
        </ModalFooter>
      </Modal>
      <Button kind="success" testId="complete-project-button" loading={isLoading} disabled={isLoading} onClick={() => setIsOpen(true)}>
        Complete Project
      </Button>
    </>;
};
export default CompleteProjectButton;